import GrowthCampaignsComponent from '../Components/Growth/GrowthCampaignsComponent';

function GrowthCampaignsPage() {
  return <GrowthCampaignsComponent />;
}

export default GrowthCampaignsPage;